module.exports = __webpack_public_path__ + "img/mainland.b159177f.png";